<template>
  <div class="item-cell">
    <div class="title">{{ item.label }}</div>
    <div class="set"><UserSelect :datas="conditionValue" @onChecked="handleChecked" /></div>
    <div class="operate">
      <el-button @click="handleDel(item)" type="text" icon="el-icon-delete" />
    </div>
  </div>
</template>

<script>
import { mixinBranch } from '../../mixins'
import UserSelect from '@/framework/components/user/select'
export default {
  mixins: [mixinBranch],
  components: {
    UserSelect
  },
  methods: {
    handleChecked(users) {
      const conditionValue = []
      if (users.length) {
        users.map(user => {
          const {
            id,
            name
          } = user
          conditionValue.push({
            id,
            name
          })
        })
      }
      this.conditionValue = conditionValue
    }
  },
  mounted() {
    const {
      conditionValue
    } = this.item
    console.log(this.item)
    if (conditionValue?.length) {
      this.conditionValue = conditionValue
    }
  }
}
</script>

<style lang='scss' scoped>
@import './item.scss';
</style>
